import { api } from '@/lib/api/client'
import type { OrganizationOnboarding } from '@/features/organizations/types/organization'

/** `GET /organizations/{organization}/onboarding` returns its White Label onboarding progress. */
export async function getOrganizationOnboarding(
  organizationId: number,
): Promise<OrganizationOnboarding> {
  const { data } = await api.get<{ data: OrganizationOnboarding }>(
    `/organizations/${organizationId}/onboarding`,
  )

  return data.data
}
